import ApiConnector from '../connector/ApiConnector';
import Article from '../model/Article';
import PriceItem from '../model/PriceItem';
import MenuRepository from './MenuRepository';

export default class ArticleRepository {

    private apiConnector:ApiConnector;
    private menuRepository:MenuRepository;

	constructor() {
        this.apiConnector = new ApiConnector();
        this.menuRepository = new MenuRepository();
	}


    getArticles() {
       
    }

    private getProductPrices(pricesObject:any,menu:any) {
        let keys = Object.getOwnPropertyNames(pricesObject)
        let prices:Array<PriceItem> = []
        keys.forEach(key => {
            prices.push(new PriceItem(menu.groessen[key],pricesObject[key]))
        })
        return prices
    }

    findById(id:any) {
        return this.menuRepository.getMenu().then(menu => {
           let productObject = menu.produkte[id]
           let prices = this.getProductPrices(productObject.Preise,menu)
           let article = new Article(productObject.Name,prices,false,productObject.ID,'icon',productObject.Beschreibung)
           return article
        })
    }
}